import lazy from '@lok/utils/lazyWithRetry';

export const protectedRoutes = [
  {
    key: 'home',
    path: '/dashboard',
    component: lazy(() => import('@lok/pages/dashboard')),
    hasRightSidebar: false
  },
  {
    key: 'modules',
    path: '/modules',
    component: lazy(() => import('@lok/pages/modules')),
    hasRightSidebar: false
  },
  {
    key: 'courseDetails',
    path: '/courses/:courseId',
    component: lazy(() => import('@lok/pages/modules'))
  },
  {
    key: 'coursePreview',
    path: '/courses/:courseId/preview',
    component: lazy(() => import('@lok/pages/coursePreview')),
    hasRightSidebar: false
  },
  {
    key: 'modulesDetails',
    path: '/modules/:modulesId',
    component: lazy(
      () => import('@lok/pages/modules/Details')
    ),
    hasRightSidebar: false
  },
  {
    key: 'lessonDetails',
    path: '/modules/:modulesId/lessons/:lessonId',
    component: lazy(
      () => import('@lok/pages/modules/Details')
    ),
    hasRightSidebar: true
  },
  {
    key: 'cohorts',
    path: '/cohorts',
    component: lazy(() => import('@lok/pages/cohorts'))
  },
  {
    key: 'resources',
    path: '/resources',
    component: lazy(() => import('@lok/pages/resources'))
  },
  {
    key: 'discussion',
    path: '/discussion',
    hasRightSidebar: false,
    component: lazy(() => import('@lok/pages/discussion'))
  },
  {
    key: 'announcements',
    path: '/announcements',
    component: lazy(
      () => import('@lok/pages/dashboard/Annoucement')
    )
  },
  {
    key: 'announcements',
    path: '/announcements/:newsId',
    component: lazy(
      () => import('@lok/pages/announcements')
    )
  },
  {
    key: 'calendar',
    path: '/calendar',
    component: lazy(() => import('@lok/pages/events')),
    hasRightSidebar: false
  },
  {
    key: 'settingsPage',
    path: '/settings/*',
    component: lazy(() => import('@lok/pages/settings'))
  },
  {
    key: 'pages',
    path: '/page/:pageId',
    component: lazy(() => import('@lok/pages/staticPages'))
  },
  {
    key: 'not-found',
    path: '/404',
    component: lazy(() => import('@lok/pages/404'))
  }
];

// Super-admin route group. Lazy-loaded so the learner bundle isn't bloated
// by admin tooling (revisit in Phase 1 if LCP regresses — see open question
// in the plan about a separate entrypoint). Mounted in AllRoutes behind
// SuperAdminRoute, which enforces user.type === 'superuser'.
export const superAdminRoutes = [
  {
    key: 'super-admin-home',
    path: '/super-admin',
    component: lazy(() => import('@lok/pages/super-admin'))
  },
  {
    key: 'super-admin-users',
    path: '/super-admin/users',
    component: lazy(() => import('@lok/pages/super-admin/users'))
  },
  {
    key: 'super-admin-clients',
    path: '/super-admin/clients',
    component: lazy(() => import('@lok/pages/super-admin/clients'))
  },
  {
    key: 'super-admin-client-detail',
    path: '/super-admin/clients/:id',
    component: lazy(() => import('@lok/pages/super-admin/clients/ClientDetail'))
  },
  {
    key: 'super-admin-library',
    path: '/super-admin/library',
    component: lazy(() => import('@lok/pages/super-admin/library'))
  },
  {
    key: 'super-admin-reports',
    path: '/super-admin/reports',
    component: lazy(() => import('@lok/pages/super-admin/reports'))
  },
  {
    key: 'super-admin-content',
    path: '/super-admin/content',
    component: lazy(() => import('@lok/pages/super-admin/content'))
  },
  {
    key: 'super-admin-goals',
    path: '/super-admin/goals',
    component: lazy(() => import('@lok/pages/super-admin/goals'))
  },
  {
    key: 'super-admin-announcements',
    path: '/super-admin/announcements',
    component: lazy(() => import('@lok/pages/super-admin/announcements'))
  }
];

// Routes reachable in BOTH authenticated and unauthenticated states. Backend one-click
// unsubscribe links land users here carrying a signed ?token=, so the page must render
// without an active session; but already-signed-in users following the same email link
// shouldn't be bounced either.
export const openRoutes = [
  {
    key: 'emailUnsubscribed',
    path: '/email-preferences/unsubscribed',
    component: lazy(
      () => import('@lok/pages/email-preferences/Unsubscribed')
    )
  },
  {
    key: 'emailPreferences',
    path: '/email-preferences',
    component: lazy(() => import('@lok/pages/email-preferences'))
  }
];

export const publicRoutes = [
  {
    key: 'resetPassword',
    path: '/password/reset/confirm/',
    component: lazy(() => import('@lok/pages/login/reset/'))
  },
  {
    key: 'login',
    path: '/login',
    component: lazy(() => import('@lok/pages/login/SignIn'))
  },
  // {
  //   key: 'signUp',
  //   path: `/sign-up`,
  //   component: lazy(() => import('@/views/auth/SignUp')),
  //
  // },
  {
    key: 'forgotPassword',
    path: `/forgot-password`,
    component: lazy(
      () => import('@lok/pages/login/ForgotPassword')
    )
  },
  {
    key: 'inviteRedeem',
    path: '/invite/:slug',
    component: lazy(() => import('@lok/pages/invite'))
  },
  {
    key: 'inviteVerify',
    path: '/invite/verify',
    component: lazy(() => import('@lok/pages/invite/Verify'))
  }
];
